import createReducer from '../createReducer'
import {
  CREATE_ACTIVITY_STORY_SUCCESS,
  CREATE_ACTIVITY_STORY_LOADING,
  CREATE_ACTIVITY_STORY_ERROR,
  GET_ACTIVITY_FEED_SUCCESS,
  LIKE_STORY_LOADING,
  LIKE_STORY_SUCCESS,
  UNLIKE_STORY_LOADING,
  POST_COMMENT_SUCCESS,
  DELETE_COMMENT_SUCCESS,
  DELETE_STORY_SUCCESS,
  GET_STORY_COMMENTS_SUCCESS,
} from './constants'

const initialState = {
  activityStories: [],
  createActivityStoryLoading: false,
}

export default createReducer(initialState, {
  [CREATE_ACTIVITY_STORY_LOADING]: (state) => {
    return { ...state, createActivityStoryLoading: true }
  },
  [CREATE_ACTIVITY_STORY_SUCCESS]: (state, action) => {
    const story = action.payload.value.data
    story.template = {
      title: '{{object.text}}',
    }

    const updatedActivityStories = [story, ...state.activityStories]
    return {
      ...state,
      createActivityStoryLoading: false,
      activityStories: updatedActivityStories,
    }
  },
  [CREATE_ACTIVITY_STORY_ERROR]: (state) => {
    return { ...state, createActivityStoryLoading: false }
  },

  [GET_ACTIVITY_FEED_SUCCESS]: (state, action) => {
    const activityStories = action.payload.data._embedded.activity_stories
    return {
      ...state,
      activityStories: activityStories,
    }
  },

  [LIKE_STORY_LOADING]: (state, action) => {
    const { storyId, userId } = action.meta

    const updatedActivityStories = state.activityStories.map(story => {
      if (story.id === storyId) {
        story.likes = story.likes || {}
        story.likes.count = story.likes.count || 0
        story.likes.items = story.likes.items || []
        story.likes.items.unshift({
          actor: {
            id: userId,
          },
        })

        story.likes.replied = true
        story.likes.count = story.likes.count + 1

        return story
      }

      return story
    })

    return {
      ...state,
      activityStories: updatedActivityStories,
    }
  },

  [LIKE_STORY_SUCCESS]: (state, action) => {
    const { storyId } = action.meta
    const updatedActivityStories = state.activityStories.map(story => {
      if (story.id === storyId) {
        story.likes.reply_id = action.payload.data.id
        return story
      }

      return story
    })

    return {
      ...state,
      activityStories: updatedActivityStories,
    }
  },

  [UNLIKE_STORY_LOADING]: (state, action) => {
    const { storyId, userId } = action.meta
    const updatedActivityStories = state.activityStories.map(story => {
      if (storyId === story.id) {
        story.likes.replied = false
        delete story.likes.reply_id

        story.likes.items = story.likes.items.filter(item => {
          return item.actor.id !== userId
        })

        story.likes.count = story.likes.items.length

        return story
      }

      return story
    })

    return {
      ...state,
      activityStories: updatedActivityStories,
    }
  },

  [POST_COMMENT_SUCCESS]: (state, action) => {
    const { storyId } = action.meta
    const comment = action.payload.data

    const updatedActivityStories = state.activityStories.map(story => {
      if (story.id === storyId) {
        story.comments = story.comments || {}
        story.comments.items = story.comments.items || []
        story.comments.count = story.comments.count || 0
        story.comments.count = story.comments.count + 1
        story.comments.items.push(comment)
        return story
      }

      return story
    })

    return {
      ...state,
      activityStories: updatedActivityStories,
    }
  },

  [DELETE_COMMENT_SUCCESS]: (state, action) => {
    const { storyId, commentId } = action.meta

    const updatedActivityStories = state.activityStories.map(story => {
      if (story.id === storyId) {
        story.comments.items = story.comments.items.filter(comment => {
          return commentId !== comment.id
        })

        story.comments.count = story.comments.count - 1

        return story
      }

      return story
    })

    return {
      ...state,
      activityStories: updatedActivityStories,
    }
  },

  [DELETE_STORY_SUCCESS]: (state, action) => {
    const { storyId } = action.meta
    const updatedActivityStories = state.activityStories.filter(story => storyId !== story.id)
    return {
      ...state,
      activityStories: updatedActivityStories,
    }
  },

  [GET_STORY_COMMENTS_SUCCESS]: (state, action) => {
    const { storyId } = action.meta
    const commentItems = action.payload.data._embedded.activity_stories

    const updatedActivityStories = state.activityStories.map(story => {
      if (storyId === story.id) {
        story.comments.items = commentItems
        return story
      }

      return story
    })

    return {
      ...state,
      activityStories: updatedActivityStories,
    }
  },
})



// WEBPACK FOOTER //
// ./src/services/feed/reducer.js